import { ReactElement } from "react";
import { IconProps } from "./iconPropsTypes";

export default function SchoolVisit({
  height = "24px",
  width = "24px",
  fill = "#1F4F9D"
}: IconProps): ReactElement {
  return (
    <svg
      height={height}
      version="1.1"
      viewBox="0 0 21 20"
      width={width}
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>school visit</title>
      <g
        fill="none"
        fillRule="evenodd"
        id="Symbols"
        stroke="none"
        strokeWidth="1"
      >
        <g id="school-visit">
          <circle cx="10" cy="10" fill={fill} id="Oval" r="10" />
          <g fill="#FFFFFF" id="icn-/-school">
            <path
              d="M13.75,3.75 L13.75,6.24958796 L16.25,6.25 L16.25,15.625 L3.75,15.625 L3.75,6.25 L6.25,6.24958796 L6.25,3.75 L13.75,3.75 Z M5,7.49958796 L5,14.374588 L6.25,14.374 L6.25,7.5 L5,7.49958796 Z M12.5,4.99958796 L7.5,4.99958796 L7.5,14.374 L8.125,14.374 L8.125,11.5234375 L11.875,11.5234375 L11.875,14.374 L12.5,14.374 L12.5,4.99958796 Z M15,7.49958796 L13.75,7.5 L13.75,14.374 L15,14.374588 L15,7.49958796 Z M10.625,12.773338 L9.375,12.773338 L9.375,14.023338 L10.625,14.023338 L10.625,12.773338 Z M10,6.25 C11.0355339,6.25 11.875,7.08946609 11.875,8.125 C11.875,9.16053391 11.0355339,10 10,10 C8.96446609,10 8.125,9.16053391 8.125,8.125 C8.125,7.08946609 8.96446609,6.25 10,6.25 Z M10,7.5 C9.65482203,7.5 9.375,7.77982203 9.375,8.125 C9.375,8.47017797 9.65482203,8.75 10,8.75 C10.345178,8.75 10.625,8.47017797 10.625,8.125 C10.625,7.77982203 10.345178,7.5 10,7.5 Z"
              id="school"
            />
          </g>
        </g>
      </g>
    </svg>
  );
}
